const path = window.location.pathname;
let basePath = window.location.origin;

if (path.startsWith("/gss-")) {
    const i = path.indexOf("/", 5);

    basePath += i !== -1 ? path.slice(0, i) : path;
}

const restPath = `${basePath}/rest`;

export const BasePath = {
    get(): string {
        return basePath;
    },
    rest(): string {
        return restPath;
    },
};
